module.exports = __webpack_public_path__ + "img/social-media-linkedin.8a211719.svg";